<script lang="ts">
	import { applyAction, enhance } from '$app/forms';
	import { superForm } from 'sveltekit-superforms/client';
	import * as Alert from '#lib/components/ui/alert/index.js';
	import type { PageData } from './$types';
	import { Label } from '#lib/components/ui/label/index.js';
	import { Input } from '#lib/components/ui/input/index.js';
	import ButtonWithLoading from '#lib/components/ButtonWithLoading/ButtonWithLoading.svelte';
	import { browser } from '$app/env';
	import { page } from '$app/state';
	import { cn } from '#lib/utils.js';
	import Button from '#lib/components/ui/button/button.svelte';
	import * as m from '#lib/paraglide/messages.js';
	import Branding from '../_components/Branding.svelte';

	interface Props {
		data: PageData;
	}

	let { data }: Props = $props();

	const formData = () => data.form;
	const { form, errors, allErrors } = superForm(formData(), {
		onUpdate: ({ form }) => {
			$errors = form.errors;
		}
	});
	let isLoading: boolean = $state(false);

	let showRedirectRequestPassword: boolean = $state(false);

	if (page.url.searchParams.get('redirectRequestPassword') === 'true' && browser) {
		showRedirectRequestPassword = true;
	}
</script>

<svelte:head>
	<title>{m.fresh_even_pig_ripple()}</title>
	<meta name="description" content={m.aware_mild_newt_evoke()} />
</svelte:head>

<div class="grid md:grid-cols-2 min-h-screen">
	<!-- Form panel -->
	<form
		class="flex flex-col justify-start px-8 pt-[30%] pb-8 md:px-16 w-full"
		method="POST"
		use:enhance={() => {
			isLoading = true;
			return async ({ result }) => {
				isLoading = false;
				await applyAction(result);
			};
		}}
	>
		<!-- Branding -->
		<Branding />

		<!-- Heading -->
		<div class="mb-8">
			<h1 class="font-display text-3xl font-bold text-foreground mb-1">
				{m.still_heavy_porpoise_skip()}
			</h1>
			<p class="font-body text-sm text-muted-foreground">Connecte-toi pour accéder à ton espace.</p>
		</div>

		{#if showRedirectRequestPassword}
			<Alert.Root class="border-green-500 mb-6">
				<Alert.Title class="text-green-800">
					{m.bold_same_baboon_sew()}
				</Alert.Title>
			</Alert.Root>
		{/if}

		{#each $allErrors as error}
			{#if error.path === '_errors'}
				<Alert.Root class="border-red-500 mb-6">
					<Alert.Title class="text-red-800">{error.messages.join('.')}</Alert.Title>
				</Alert.Root>
			{/if}
		{/each}

		<div class="flex flex-col gap-5 max-w-sm">
			<!-- Email -->
			<div class="flex flex-col gap-2">
				<Label class={cn($errors?.email && 'text-red-500')} for="email">
					{m.good_misty_koala_edit()}
				</Label>
				<Input
					class={cn('border text-base', $errors?.email && 'border-red-500')}
					id="email"
					name="email"
					type="email"
					bind:value={$form.email}
					tabindex={1}
				/>
				{#if $errors?.email}
					<p class="font-body text-xs text-destructive">{$errors.email}</p>
				{/if}
			</div>

			<!-- Password -->
			<div class="flex flex-col gap-2">
				<div class="flex items-center justify-between">
					<Label class={cn($errors?.password && 'text-red-500')} for="password">
						{m.stale_royal_thrush_read()}
					</Label>
					<Button
						class="h-auto p-0 font-body text-xs text-muted-foreground"
						variant="link"
						href="/password/request"
						tabindex={4}
					>
						{m.ok_grand_firefox_intend()}
					</Button>
				</div>
				<Input
					class={cn('border text-base', $errors?.password && 'border-red-500')}
					id="password"
					name="password"
					type="password"
					bind:value={$form.password}
					tabindex={2}
				/>
			</div>

			<ButtonWithLoading {isLoading} type="submit" class="w-full mt-1" tabindex={3}>
				{m.muddy_sour_reindeer_dart()}
			</ButtonWithLoading>
		</div>
	</form>

	<!-- Image panel -->
	<div class="hidden md:block view-transition">
		<img class="min-h-screen w-full object-cover" alt="Salle de sport" src="/login-image.webp" />
	</div>
</div>
